import React, { createContext, useContext } from 'react';
import type { ChatMessageModel, ClarificationResponse } from '../client/SmartAssistantBackendClient';

export type AgentSelectionModel = {
  assistantInternalName: string;
  promptConfigKey: string | null;
  includeProfile: boolean;
};

export type CurrentThreadContextValue = {
  threadId: string | null;
  history: ChatMessageModel[];
  awaitingResponse: boolean;
  queuedMessages: Array<{ id: string; text: string; createdAt: number }>;
  submittedClarifications: Record<string, boolean>;
  agentSelection: AgentSelectionModel;
  setAgentSelection: (next: AgentSelectionModel) => void;
  setCurrentThreadSelection: (chatId: string | null, history: ChatMessageModel[], agentSelection?: AgentSelectionModel | null) => void;
  replaceHistory: (messages: ChatMessageModel[], chatId?: string | null) => void;
  approveToolCall: (messages: ChatMessageModel[]) => void;
  addMessage: (text: string, clarification?: ClarificationResponse, options?: { broadcast?: boolean }) => void;
  cancelQueuedMessage: (id: string) => void;
  setLiveShareBroadcaster: (sender: ((messages: ChatMessageModel[], chatId?: string | null) => void) | null) => void;
};

const CurrentThreadContext = createContext<CurrentThreadContextValue | null>(null);

export function CurrentThreadProvider({
  value,
  children,
}: {
  value: CurrentThreadContextValue;
  children: React.ReactNode;
}) {
  return <CurrentThreadContext.Provider value={value}>{children}</CurrentThreadContext.Provider>;
}

export function useCurrentThreadContext() {
  const ctx = useContext(CurrentThreadContext);
  if (!ctx) {
    throw new Error('useCurrentThreadContext must be used within CurrentThreadProvider');
  }
  return ctx;
}
